import { render, staticRenderFns } from "./MStoreGroupedTable.vue?vue&type=template&id=04207cc5&"
import script from "./MStoreGroupedTable.vue?vue&type=script&lang=ts&"
export * from "./MStoreGroupedTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports